import { ProjectCardProps } from "@/features/Home/components";
import { api } from ".";
import { create } from "zustand";
import { TBlog } from "@/app/(user)/blogs/[slug]/page";

const blogsState = create<{
  initialized: boolean;
  blogs: ProjectCardProps[];
}>(() => ({
  initialized: false,
  blogs: [],
}));
const blogState = create<{ blogs: Record<number, TBlog> }>(() => ({
  blogs: [],
}));

const blogApi = {
  create: async (body: {}) => {
    return await api.post("blogs", body);
  },
  update: async (body: {}) => {
    return await api.put("blogs", body);
  },
  list: async ({
    blogTypeId,
    limit,
  }: {
    blogTypeId?: number;
    limit?: number;
  }) => {
    const blogs = blogsState.getState();
    if (blogs.initialized && blogs.blogs?.length > 0) {
      return {
        blogs: blogs.blogs,
        total: blogs.blogs?.length || 0,
      };
    }

    let url = "blogs";
    if (blogTypeId) {
      url = url + `?blogTypeId=${blogTypeId}&limit=${limit}`;
    }
    const { data } = await api.get(url);
    blogsState.setState({ initialized: true, blogs: data.data.blogs || [] });
    return {
      blogs: data.data.blogs,
      total: data.data.blogs?.length || 0,
    };
  },
  detail: async (id: number) => {
    const blogs = blogState.getState();
    const blog = blogs.blogs[id];
    if (blog) return blog;
    const { data } = await api.get(`blogs/${id}`);
    blogState.setState((prev) => ({
      blogs: { ...prev.blogs, [id]: data.data.blog },
    }));
    return data.data.blog;
  },
};

export default blogApi;
